import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { downloadPass, downloadGooglePass } from '../../redux/actions/transientAction' // Import the Redux action
import apple_wallet from '../../assets/img/wallet_icon/apple_wallet.png'
import google_wallet from '../../assets/img/wallet_icon/google_wallet.png'
import { getDeviceType } from '../../utils/helper'

const PassWalletButtons = ({ ticketId }) => {
    const dispatch = useDispatch()
    let deviceType = getDeviceType()
    // Function to handle wallet pass download
    const handleDownload = (type = 'apple') => {
        if (type === 'apple') {
            dispatch(downloadPass(ticketId)) // Dispatch Redux action
        } else {
            dispatch(downloadGooglePass(ticketId)) // Dispatch Redux action   
        }
    }

    return (
        <button
            type="button"
            onClick={() => handleDownload(`${deviceType ? 'apple' : 'google'}`)}
            className='btn w-100 border-btn d-flex gap-2 justify-content-center align-items-center bg-dark text-white py-2 px-1 rounded-5'>
            <img
                src={deviceType ? apple_wallet : google_wallet}
                alt={deviceType ? 'Apple Wallet' : 'Google Wallet'}
                style={{ height: '25px' }} // Adjust size
            />
            <span className='ms-1' style={{ fontSize: '18px' }}>Add to {deviceType ? 'Apple' : 'Google'} Wallet</span>
        </button>
    )
}

PassWalletButtons.propTypes = {
    ticketId: PropTypes.string.isRequired
}

export default PassWalletButtons
